import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a64c97c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select_wrap" }
const _hoisted_2 = { class: "cache_operate" }
const _hoisted_3 = { class: "cache_operate" }
const _hoisted_4 = { class: "cache_operate_right" }
const _hoisted_5 = { class: "live_info" }
const _hoisted_6 = { class: "txt_high" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "content_square" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "video_container_figure" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "video_container_figure_duration" }
const _hoisted_13 = { class: "video_container_caption" }
const _hoisted_14 = { class: "video_container_caption_title text_elip" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "video_container_caption_info" }
const _hoisted_17 = { class: "video_container_caption_info" }
const _hoisted_18 = { class: "video_container_check" }
const _hoisted_19 = { class: "more_to" }

import { reactive, ref, onMounted } from 'vue';
import { Input, Spin } from 'ant-design-vue';
import { BaseSearchClass } from '@/types/base';
import http from '@/api';
import { Video, Videoform } from '../type';
import { useDebounce } from '@/hooks/useDebounce';

const __default__ = { name: 'ModalCreateVideo' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['get:sonList'],
  setup(__props, { expose, emit }) {

const aInputSearch = Input.Search;
const aSpin = Spin;

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 8, // 每页条数
  totalSize: 0, // 总页数
  options: ['12', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

const selectKeys = ref({});
const ListData = ref<Video[]>([]);
const queryForm = reactive<BaseSearchClass>({
  keywords: '',
});
let readyForLoad = true; //默认允许加载一次
const getList = useDebounce(async (current?: number) => {
  if (readyForLoad) {
    readyForLoad = false;
    const search = {
      page: current ? current : pageConfig.current,
      page_num: pageConfig.pageSize,
      ...queryForm,
    };
    const res = await http.media.getDemandVideoList({ params: { ...search } });
    const { current_page, total, data } = res.data.data;
    const resData = data.map((e: Video) => {
      selectKeys.value[e.id] = false;
      return e;
    });

    if (current === 1) {
      ListData.value = [];
    }
    ListData.value.push(...resData);
    pageConfig.current = current_page;
    pageConfig.totalSize = total;
    pageConfig.current++;
    readyForLoad = true;
  }
});
getList();

const getSelectData = () => {
  const arr: Videoform[] = [];
  ListData.value.forEach((e, index) => {
    if (selectKeys.value[e.id] === true) {
      arr.push({
        cover_url: e.cover_url,
        definition: e.definition,
        duration: e.duration,
        id: e.id,
        isUpload: e.isUpload,
        play_url: e.video_url,
        start_at: e.created_at,
        title: e.title,
        video_id: e.video_id,
        isShowEdit: false, // 自定义属性
      });
    }
  });
  choice_all.value = false;
  changeItemMarkAll();
  emit('get:sonList', arr);
};

const choice_all = ref(false);
const changeItemMarkAll = () => {
  if (choice_all.value === true) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeItemMark = (item: Video) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
};
const handleScroll = () => {
  //窗口滚要做的操作写这里
  let sh = listRef.value.scrollHeight || document.body.scrollHeight; // 滚动条高度
  let st = listRef.value.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
  let ch = listRef.value.clientHeight || document.body.clientHeight; // 滚动条外容器的高度
  // console.log('sh-%s---st-%s----ch-%s', sh, st, ch);

  if (st + ch >= sh - 50) {
    //快到底时----加载
    if (pageConfig.totalSize && ListData.value.length < pageConfig.totalSize) {
      // console.log('1234');
      getList(); // 加载数据的方法
    }
  }
};
const listRef = ref();
// 滚动事件
onMounted(() => {
  //监听页面滚动事件
  listRef.value.addEventListener('scroll', handleScroll);
});
expose({ getSelectData, choice_all, changeItemMarkAll });

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(aInputSearch), {
          value: queryForm.keywords,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.keywords) = $event)),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(getList)(1)), ["enter"])),
          placeholder: "搜索直播间标题",
          class: "search_input"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(" 直播间"),
            _createElementVNode("span", _hoisted_6, _toDisplayString(pageConfig.totalSize), 1)
          ]),
          _createVNode(_component_a_checkbox, {
            class: "checkbox",
            checked: choice_all.value,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((choice_all).value = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (changeItemMarkAll()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("全选")
            ]),
            _: 1
          }, 8, ["checked"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "sublist",
      ref_key: "listRef",
      ref: listRef
    }, [
      (ListData.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListData.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["video_wrap item_select", selectKeys.value[item.id] ? 'item_selected' : '']),
                    onClick: ($event: any) => (changeItemMark(item))
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "video_container_figure_img",
                        src: item.cover_url
                      }, null, 8, _hoisted_11),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(item.duration), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h3", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_16, "上传时间：" + _toDisplayString(item.created_at), 1),
                      _createElementVNode("p", _hoisted_17, "分辨率：" + _toDisplayString(item.resolution), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_checkbox, {
                          checked: selectKeys.value[item.id],
                          "onUpdate:checked": ($event: any) => ((selectKeys.value[item.id]) = $event)
                        }, null, 8, ["checked", "onUpdate:checked"])
                      ])
                    ])
                  ], 10, _hoisted_9)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("h3", null, [
                _createVNode(_unref(aSpin), { class: "mright" }),
                _createTextVNode("加载中···")
              ], 512), [
                [_vShow, ListData.value.length < pageConfig.totalSize]
              ]),
              _withDirectives(_createElementVNode("h3", null, "已经没有更多了", 512), [
                [_vShow, ListData.value.length >= pageConfig.totalSize]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})